import * as Sentry from '@sentry/browser';
import {loggerMode} from '../utils/urlParams';

const DEV = 'development';
const LOG_STYLES = 'display: inline-block; color: #f8f85a; background: rgb(0, 6, 141); padding: 1px 4px; border-radius: 3px;';

const processQueue = [];
const processQueueIds = [];

/**
 * Returns true in development mode.
 * @return {boolean}
 */
const inDevelopment = () => loggerMode() || process.env.NODE_ENV === DEV;

/**
 * Prints pretty log into console in development mode.
 * @param {string} msg
 * @param {any} data
 * @param {string} component
 */
export const logger = (id, msg, data = '', component = 'CMP') => {
  if (typeof data === 'object') {
    try {
      data = JSON.stringify(data);
    } catch (error) {
      if (inDevelopment()) {
        // eslint-disable-next-line no-console
        console.error(error);
      } else {
        Sentry.addBreadcrumb({
          message: msg,
          data,
          level: Sentry.Severity.Info
        });
      }
      data = '';
    }
  }

  processQueue.push(msg + data);
  processQueueIds.push(id);
  if (inDevelopment()) {
    // eslint-disable-next-line no-console
    console.log(`%c${component}`, LOG_STYLES, msg, data);
  }
};

export const getProcessQueue = () => processQueue.reduce((acc, curr) => (acc += `${curr} / `), '');

export const getProcessQueueIds = () => processQueueIds.reduce((acc, curr) => (acc += `${curr}/`), '');
